@if (loading) {
  <app-loading-indicator></app-loading-indicator>
} @else {
  <ng-content></ng-content>
}
